/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShipListItem } from './ShipListItem';
import {
    ShipListItemFromJSON,
    ShipListItemFromJSONTyped,
    ShipListItemToJSON,
} from './ShipListItem';

/**
 * Zero or more ships found inside the area.
 * @export
 * @interface ShipListResponse
 */
export interface ShipListResponse {
    /**
     * 
     * @type {Array<ShipListItem>}
     * @memberof ShipListResponse
     */
    records?: Array<ShipListItem>;
}

/**
 * Check if a given object implements the ShipListResponse interface.
 */
export function instanceOfShipListResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipListResponseFromJSON(json: any): ShipListResponse {
    return ShipListResponseFromJSONTyped(json, false);
}

export function ShipListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipListItemFromJSON)),
    };
}

export function ShipListResponseToJSON(value?: ShipListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipListItemToJSON)),
    };
}

